import { Box, styled } from "@mui/material";

export const TopUpWrapper = styled(Box)(() => {
    return {

    }
})